// Category landing-page configuration.
//
// Each entry maps a URL slug to:
//   - the category name as stored in the DB (must match BUSINESS_CATEGORIES on backend)
//   - the hero artwork URL (uploaded category graphics from the user)
//   - a short, human-readable description shown below the title
//
// Only categories that have hero artwork live here. Categories without artwork
// fall back to the standard /directory?category=... behaviour.

export const CATEGORY_HEROES = {
  "food-beverage": {
    name: "Food & Beverage",
    image: "https://customer-assets.emergentagent.com/job_ff5ff6a6-ab60-4aed-b35d-dded2ad0a697/artifacts/dhypaety_90C2F250-1E44-47A9-8998-8B693503F85A.png",
    tagline: "Culture. Flavor. Innovation. Community.",
    description:
      "Black-owned restaurants, bars, caterers, bakeries, and food artisans bringing culture to the table.",
  },
  "health-fitness": {
    name: "Health & Fitness",
    image: "https://customer-assets.emergentagent.com/job_ff5ff6a6-ab60-4aed-b35d-dded2ad0a697/artifacts/kd6eechs_1178BE12-9C54-4535-B15F-5D7568C783E9.png",
    tagline: "Discipline. Vitality. Longevity. Legacy.",
    description:
      "Coaches, gyms, wellness studios, and trainers building strength inside and out.",
  },
  "medical": {
    name: "Medical Services",
    image: "https://customer-assets.emergentagent.com/job_ff5ff6a6-ab60-4aed-b35d-dded2ad0a697/artifacts/s0qnohbj_CEF98783-7873-4637-A501-CAD834B41E85.png",
    tagline: "Care. Excellence. Community. Healing together.",
    description:
      "Black-owned primary care, mental health, dental, specialty care, pharmacy, and lab services.",
  },
  "travel": {
    name: "Travel",
    image: "https://customer-assets.emergentagent.com/job_ff5ff6a6-ab60-4aed-b35d-dded2ad0a697/artifacts/cyfhf36x_1CAABF56-CBE2-40DA-AD20-6DA299BA09D5.png",
    tagline: "Exploration. Freedom. Elevated living.",
    description:
      "Travel advisors, tour operators, curated stays, and unforgettable experiences for the modern explorer.",
  },
  "influencer": {
    name: "Influencer/Content Creator",
    image: "https://customer-assets.emergentagent.com/job_ff5ff6a6-ab60-4aed-b35d-dded2ad0a697/artifacts/g1pcnoh6_5AA8DABE-99FD-4105-A49B-15E2E7585A10.png",
    tagline: "Create. Influence. Inspire.",
    description:
      "Creators, podcasters, streamers, and personalities building audiences and brands worth following.",
  },
  "beauty-wellness": {
    name: "Beauty & Wellness",
    image: "https://customer-assets.emergentagent.com/job_ff5ff6a6-ab60-4aed-b35d-dded2ad0a697/artifacts/9x6wa1cv_5E024D2F-3102-4817-A141-E4995EB9DE47.png",
    tagline: "Nourish. Glow. Thrive.",
    description:
      "Spas, skincare studios, hair artists, and wellness practitioners helping our community look and feel its best.",
  },
  "fashion-apparel": {
    name: "Fashion & Apparel",
    image: "https://customer-assets.emergentagent.com/job_ff5ff6a6-ab60-4aed-b35d-dded2ad0a697/artifacts/9c4sr3cn_DECECC7E-AEDB-4A4F-88FD-7E98BFBD2160.png",
    tagline: "Style. Identity. Power.",
    description:
      "Designers, boutiques, streetwear labels, and tailors crafting the next era of culture-forward fashion.",
  },
  "home-living": {
    name: "Home & Living",
    image: "https://customer-assets.emergentagent.com/job_ff5ff6a6-ab60-4aed-b35d-dded2ad0a697/artifacts/bap7pc80_2AB6E334-675B-49D6-AD35-18C70760ECE5.png",
    tagline: "Rooted in culture. Built for generations.",
    description:
      "Interior designers, furniture makers, decor brands, and lifestyle artisans curating spaces that feel like home.",
  },
  "art-crafts": {
    name: "Art & Crafts",
    image: "https://customer-assets.emergentagent.com/job_ff5ff6a6-ab60-4aed-b35d-dded2ad0a697/artifacts/onmyo1bz_333F48D0-D0F9-4768-9142-1B2EB8DE1C8E.png",
    tagline: "Create. Culture. Express. Legacy.",
    description:
      "Painters, sculptors, illustrators, jewelers, and craftspeople telling our stories through original work.",
  },
  "technology": {
    name: "Technology",
    image: "https://customer-assets.emergentagent.com/job_ff5ff6a6-ab60-4aed-b35d-dded2ad0a697/artifacts/0dg7ofd3_2227781F-A151-4EB6-9AA6-FE5F904FAAC8.png",
    tagline: "Innovate. Build. Own the future.",
    description:
      "Engineers, founders, product teams, and creators building the next wave of Black-led technology.",
  },
};

// Reverse lookup: given a category name (as stored in the DB), return its slug
// or null if the category doesn't have a hero page yet.
export function slugForCategory(name) {
  if (!name) return null;
  const entry = Object.entries(CATEGORY_HEROES).find(([, v]) => v.name === name);
  return entry ? entry[0] : null;
}
